import moment from 'moment';

export const createHolidaysDateToNameMap = (holidays = []) => {
  const holidaysDateToNameMap = {};
  holidays.forEach((holiday) => {
    holidaysDateToNameMap[holiday.date] = holiday.name;
  });
  return holidaysDateToNameMap;
};

export const isAllowedBusinessDate = (date, holidaysDateToNameMap = {}) => {
  const day = moment(date, 'YYYY-MM-DD').day();
  return day !== 0 && day !== 6 && !holidaysDateToNameMap[date];
};

export const subtractBusinessDays = (ymd, days, holidaysDateToNameMap = {}) => {
  let m = moment(ymd, 'YYYY-MM-DD');
  let remaining = days;

  while (remaining > 0) {
    m = m.subtract(1, 'day');
    if (isAllowedBusinessDate(m.format('YYYY-MM-DD'), holidaysDateToNameMap)) remaining--;
  }
  return m.format('YYYY-MM-DD');
};

export const addBusinessDays = (ymd, days, holidaysDateToNameMap = {}) => {
  let m = moment(ymd, 'YYYY-MM-DD');
  let remaining = days;

  while (remaining > 0) {
    m = m.add(1, 'day');
    if (isAllowedBusinessDate(m.format('YYYY-MM-DD'), holidaysDateToNameMap)) remaining--;
  }
  return m.format('YYYY-MM-DD');
};

export default {
  addBusinessDays,
  createHolidaysDateToNameMap,
  isAllowedBusinessDate,
  subtractBusinessDays,
};
